export default "__VITE_ASSET__BLU_eRlY__"